var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn-hamburger",attrs:{"type":"button","aria-label":_vm.$t('Open menu'),"data-testid":"menuButton"},on:{"click":_vm.openSidebarMenu}})
}
var staticRenderFns = []

export { render, staticRenderFns }